import React, { memo } from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function CostOfInaction() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const consequences = ['Acelera el envejecimiento celular y la pérdida de memoria', 'Debilita tu sistema inmunológico', 'Aumenta el riesgo de ansiedad y depresión', 'Roba la energía que necesitas para disfrutar de tu vida'];
  return <section className="relative py-24 px-6 z-10 bg-night-900 border-t border-red-900/20" data-id="element-32">
      <div ref={ref} className={`max-w-4xl mx-auto section-reveal ${isVisible ? 'visible' : ''}`} data-id="element-33">
        <div className="text-center mb-16" data-id="element-34">
          <h3 className="text-3xl md:text-5xl font-heading font-bold text-cream-100 mb-6" data-id="element-35">
            ¿Qué pasa si no haces nada?
          </h3>
          <p className="text-xl md:text-2xl text-cream-200/80 font-heading italic max-w-2xl mx-auto" data-id="element-36">
            El insomnio no se cura solo. Cada noche sin descanso profundo...
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 mb-16" data-id="element-37">
          {consequences.map((item, i) => <div key={i} className="glass-card p-6 rounded-2xl flex items-start border-l-2 border-l-red-900/50 bg-night-800/40" data-id="element-38">
              <AlertTriangleIcon className="w-6 h-6 text-red-400/60 flex-shrink-0 mt-1" data-id="element-39" />
              <p className="ml-4 text-cream-200 text-lg leading-relaxed" data-id="element-40">
                {item}
              </p>
            </div>)}
        </div>

        <div className="text-center max-w-2xl mx-auto glass-card p-10 rounded-3xl border-gold-500/20 relative overflow-hidden" data-id="element-41">
          <div className="absolute inset-0 bg-gold-500/5 pointer-events-none" data-id="element-42" />

          <p className="text-2xl md:text-3xl font-heading font-bold text-cream-100 mb-10 relative z-10 leading-relaxed" data-id="element-43">
            No tienes que seguir así. Existe una salida — y{' '}
            <span className="text-gold-400" data-id="element-44">solo toma 10 minutos.</span>
          </p>

          <a href="#oferta" className="inline-block bg-gold-500 hover:bg-gold-400 text-night-900 font-bold text-lg py-4 px-10 rounded-full transition-all duration-300 transform hover:scale-105 animate-glow-pulse shadow-xl no-underline relative z-10" data-id="element-45">
            VER LA SOLUCIÓN AHORA
          </a>
        </div>
      </div>
    </section>;
}